/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import {
    Avatar,
    Divider,
    ListItemButton,
    ListItemAvatar,
    ListItemText,
    ListItemSecondaryAction,
    Typography
} from "@mui/material";
import { BellOutlined } from "@ant-design/icons";

const NotificationItem = (props) => {
    
    const iconColor = props?.iconColor ?? "#FFFFFF"; // FIXME use classes
    const iconBackgroundColor = props?.iconBackgroundColor ?? "#00685E"; // FIXME use classes
    const icon = props?.icon ?? <BellOutlined />;
    const when = props?.when ?? "3:00 AM";
    const textMain = props?.textMain ?? "News content ready for review.";
    const textSub = props?.textSub ?? "Due: October 12, 5PM";
    const handleItemClick = props?.handleItemClick;
    
    const isIcon = typeof icon !== "string";
    
    return (
        <>
            <ListItemButton
                // style={{ border: '1px solid red'}}
                onClick={(event) => handleItemClick(event, "manage-tasks")}
            >
                <ListItemAvatar>
                    <Avatar sx={{ color: iconColor, bgcolor: iconBackgroundColor }} >
                        {isIcon ? (
                            <div className='notification-svg-icon'>{icon}</div>
                        ) : (
                            <>{icon}</>
                        )}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    title={textMain}
                    primary={
                        <Typography variant='h6' style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                            {textMain}
                        </Typography>
                    }
                    secondary={textSub}
                />
                <ListItemSecondaryAction>
                    <Typography variant='caption' noWrap>
                        {when}
                    </Typography>
                </ListItemSecondaryAction>
            </ListItemButton>

            <Divider />
        </>
    );
};

export default NotificationItem;
